import { useRouter } from "next/router";
import posthog from "posthog-js";
import { useEffect } from "react";

// Taken from: https://posthog.com/docs/integrate/third-party/next-js#setup-and-tracking-page-views-manually
function PostHog() {
  const router = useRouter();

  useEffect(() => {
    // Init PostHog
    posthog.init("phc_hFXi79s0PtzuqS7gSMHzs0GiIMUoyxmc20kLH47MUop", {
      api_host: "https://app.posthog.com",
    });

    // Track page views
    const handleRouteChange = () => posthog.capture("$pageview");
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  return <></>;
}

export default PostHog;
